//import axios from 'axios';

import HTTP from './http';
export default {
  post(options) {
    return HTTP.post(`/${options.endpoint}`, JSON.stringify(options.data), {
      headers: {
        'Authorization': `Bearer ${options.token}`,
        'Content-Type': 'application/json;charset=UTF-8;'
      }
    });
  },
  postWithFiles(options) {
    if(this.IsFormDataSizeValid(options.data)) {
      return HTTP.post(`/${options.endpoint}`, options.data, {
        headers: {
          'Authorization': `Bearer ${options.token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
    } else {
      return Promise.reject(new Error("The total size of the attachment(s) exceed the 30MB limit. Please reduce the file size and try again."));
    }
  }, 
  delete(options) {
    return HTTP.delete(`/${options.endpoint}`, {
      headers: {
        'Authorization': `Bearer ${options.token}`,
        'Content-Type': 'application/json;charset=UTF-8;'
      },
      data:JSON.stringify(options.data)      
    });
  },
  put(options) {
    return HTTP.put(`/${options.endpoint}`, JSON.stringify(options.data), {
      headers: {
        'Authorization': `Bearer ${options.token}`,
        'Content-Type': 'application/json;charset=UTF-8;'
      }
    });
  },
  list(options) {
    return HTTP.post(`/${options.endpoint}/`, 
     JSON.stringify(options.data),{
      headers: {
        'Authorization': `Bearer ${options.token}`,
        'Content-Type': 'application/json;charset=UTF-8;'
      }
    });
  },
  get(options) {
    return HTTP.get(`/${options.endpoint}`, {
      headers: {
        'Authorization': `Bearer ${options.token}`,
      }
    });
  },
  download(options) {
    return HTTP.post(`/${options.endpoint}/`, 
    JSON.stringify(options.data),{
    responseType: 'blob',
     headers: {
       'Authorization': `Bearer ${options.token}`,
       'Content-Type': 'application/json;charset=UTF-8;'
     }
   });
  },
  putWithFiles(options){
    if(this.IsFormDataSizeValid(options.data)) {
      return HTTP.put(`/${options.endpoint}/${options.id}`, options.data, {
        headers: {
          'Authorization': `Bearer ${options.token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
    } else {
        return Promise.reject(new Error("The total size of the attachment(s) exceed the 30MB limit. Please reduce the file size and try again."));
    }
  },
  IsFormDataSizeValid(formData) {
    let totalSize = 0;

    for (let [, value] of formData.entries()) {
      if (typeof value === 'string') {
        totalSize += new Blob([value]).size;
      } else if (value instanceof File) {
        totalSize += value.size;
      }
    }
    return totalSize <= 30000000; // 30MB in bytes
  },
};
